export class WidgetNumberUtils {
  /**
   * Converts an input into a finite numeric value.
   * Returns null when the input cannot be safely coerced.
   */
  static toFiniteNumber(value: unknown): number | null {
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }

    if (typeof value === 'string') {
      const numeric = Number(value);
      return Number.isFinite(numeric) ? numeric : null;
    }

    if (value == null) {
      return null;
    }

    const coerced = Number(value);
    return Number.isFinite(coerced) ? coerced : null;
  }
}
